import { render, staticRenderFns } from "./SupervisionForm.vue?vue&type=template&id=79fbf8fd&scoped=true"
import script from "./SupervisionForm.vue?vue&type=script&lang=js"
export * from "./SupervisionForm.vue?vue&type=script&lang=js"
import style0 from "./SupervisionForm.vue?vue&type=style&index=0&id=79fbf8fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fbf8fd",
  null
  
)

export default component.exports